import { motion } from 'framer-motion';
import { SectionHeading } from '../components/SectionHeading';
import { Sticker } from '../components/Sticker';
import { birthdayConfig } from '../config';

export function ReasonsSection() {
  return (
    <section className="section-shell reasons-section">
      <div className="page-container">
        <SectionHeading
          eyebrow={birthdayConfig.copy.reasons.eyebrow}
          title={birthdayConfig.copy.reasons.title}
          description={birthdayConfig.copy.reasons.description}
        />
        <div className="reasons-grid">
          {birthdayConfig.reasons.map((reason, index) => (
            <motion.article
              key={reason.title}
              className="reason-card glass"
              initial={{ opacity: 0, y: 30, scale: 0.96 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ delay: (index % 4) * 0.09 }}
            >
              <span className="reason-icon">{reason.icon}</span>
              <h3>{reason.title}</h3>
              <p>{reason.text}</p>
            </motion.article>
          ))}
        </div>
        <Sticker src="/stickers/mochi-hug.svg" alt="Mochi cat hugging" className="reasons-sticker" />
      </div>
    </section>
  );
}
